var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgJar7(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1289 1150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#jar_7_svg__clip0_1961_6823)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M652.16 209.69H415.15c-73.15 0-132.45 59.3-132.45 132.45v68.02c0 73.15 59.3 132.45 132.45 132.45h237.01c73.15 0 132.45-59.3 132.45-132.45v-68.02c0-73.15-59.3-132.45-132.45-132.45z",
    fill: "#EEF9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.91 513.95l-54.38 107.81a72.763 72.763 0 00-8.88 34.81v340.67c0 72.84 59.05 131.9 131.9 131.9h304.49c72.84 0 131.9-59.05 131.9-131.9V656.97a72.75 72.75 0 00-9.24-35.48l-57.79-108.92",
    fill: "#EEF9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.91 513.95l-54.38 107.81a72.763 72.763 0 00-8.88 34.81v340.67c0 72.84 59.05 131.9 131.9 131.9h304.49c72.84 0 131.9-59.05 131.9-131.9V656.97a72.75 72.75 0 00-9.24-35.48l-57.79-108.92",
    stroke: "#CDE2E4",
    strokeWidth: 32,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740.26 967.78H333.34c-44.558 0-80.68 36.12-80.68 80.68 0 44.56 36.122 80.68 80.68 80.68h406.92c44.558 0 80.68-36.12 80.68-80.68 0-44.56-36.122-80.68-80.68-80.68z",
    fill: "#EEF9FA",
    stroke: "#CDE2E4",
    strokeWidth: 32,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1217.52 887.782l-201.83-153.865c-54.485-41.539-132.331-31.041-173.87 23.447l-26.646 34.952c-41.539 54.489-31.042 132.334 23.447 173.874l201.829 153.86c54.49 41.54 132.33 31.05 173.87-23.44l26.65-34.95c41.54-54.49 31.04-132.339-23.45-173.878z",
    fill: "#FD934F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1238.3 892.146l-235.66-179.655c-45.147-34.417-109.646-25.719-144.064 19.427-34.417 45.147-25.719 109.646 19.427 144.063l235.657 179.659c45.15 34.41 109.65 25.72 144.07-19.43 34.41-45.147 25.72-109.646-19.43-144.064z",
    fill: "#FED425"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1129.39 917.744l-110.32-84.108c-9.74-7.426-23.662-5.549-31.088 4.192l-1.516 1.989c-7.427 9.741-5.55 23.659 4.192 31.085l110.322 84.108c9.75 7.426 23.66 5.549 31.09-4.192l1.52-1.988c7.42-9.742 5.55-23.66-4.2-31.086z",
    fill: "#2A848E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M724.95 699.11v-42.13a72.75 72.75 0 00-9.24-35.48l-15.55-29.3M724.95 921.72V781.28",
    stroke: "#FBFDFE",
    strokeWidth: 27.97,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.67 1007.67H336.03c-20.473 0-37.07 16.6-37.07 37.07s16.597 37.07 37.07 37.07h407.64c20.473 0 37.07-16.6 37.07-37.07s-16.597-37.07-37.07-37.07z",
    fill: "#FED425",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.03 1136.68c21.097 0 38.2-13.86 38.2-30.96s-17.103-30.96-38.2-30.96-38.2 13.86-38.2 30.96 17.103 30.96 38.2 30.96z",
    fill: "#FED425",
    stroke: "#FD934F",
    strokeWidth: 14.27,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.049 660.707l-51.541-51.541a7.978 7.978 0 00-11.285 0l-51.541 51.541a7.978 7.978 0 000 11.285l51.541 51.541a7.98 7.98 0 0011.285 0l51.541-51.541a7.978 7.978 0 000-11.285z",
    fill: "#9FFC27",
    stroke: "#7ABA1E",
    strokeWidth: 7.93,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.84 668.83h31.52c1.94 0 3.51-1.57 3.51-3.51v-30.64c0-3.1-3.73-4.68-5.96-2.52l-31.52 30.64c-2.26 2.2-.7 6.03 2.45 6.03z",
    fill: "#EFFFD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715.592 961.335l-51.541-51.541a7.98 7.98 0 00-11.286 0l-51.541 51.541a7.98 7.98 0 000 11.285l51.541 51.54a7.974 7.974 0 0011.286 0l51.541-51.54a7.98 7.98 0 000-11.285z",
    fill: "#FF1F4F",
    stroke: "#DD0A41",
    strokeWidth: 7.93,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.38 969.46h31.52c1.94 0 3.51-1.57 3.51-3.51v-30.64c0-3.1-3.73-4.68-5.96-2.52l-31.52 30.64c-2.26 2.2-.7 6.03 2.45 6.03z",
    fill: "#EFFFD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.29 242.76v123.25c0 13.75 17.1 24.9 38.2 24.9s38.2-11.15 38.2-24.9V243.93l-76.39-1.17h-.01z",
    fill: "#FED425",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.68 271.6c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M491.68 311.36c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.5 242.76v123.25c0 13.75 17.1 24.9 38.2 24.9s38.2-11.15 38.2-24.9V243.93l-76.39-1.17h-.01z",
    fill: "#FED425",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.89 271.6c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M573.89 311.36c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.89 242.76v123.25c0 13.75 17.1 24.9 38.2 24.9s38.2-11.15 38.2-24.9V243.93l-76.39-1.17h-.01z",
    fill: "#FED425",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.28 271.6c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M650.28 311.36c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.4 720.79v326.08c0 13.75 17.1 24.9 38.2 24.9s38.2-11.15 38.2-24.9v-324.9l-76.39-1.17-.01-.01z",
    fill: "#FED425",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.6 739.89c21.097 0 38.2-11.148 38.2-24.9 0-13.752-17.103-24.9-38.2-24.9s-38.2 11.148-38.2 24.9c0 13.752 17.103 24.9 38.2 24.9z",
    fill: "#FED425",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.8 975.3c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M734.8 939.03c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M734.8 903.75c0 13.75-17.1 24.901-38.2 24.901s-38.2-11.151-38.2-24.901M734.8 868.061c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M734.8 831.37c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M734.8 793.53c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M734.8 755.65c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M734.8 1012.58c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.4 390.92V717c0 13.75 17.1 24.9 38.2 24.9s38.2-11.15 38.2-24.9V392.1l-76.39-1.17-.01-.01z",
    fill: "#FED425",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.6 410.02c21.097 0 38.2-11.148 38.2-24.9 0-13.752-17.103-24.9-38.2-24.9s-38.2 11.148-38.2 24.9c0 13.752 17.103 24.9 38.2 24.9z",
    fill: "#FED425",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.8 645.43c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M734.8 609.16c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M734.8 573.88c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M734.8 538.19c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M734.8 501.5c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M734.8 463.66c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M734.8 425.78c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M734.8 682.71c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.22 720.79v326.08c0 13.75 17.1 24.9 38.2 24.9s38.2-11.15 38.2-24.9v-324.9l-76.39-1.17-.01-.01z",
    fill: "#FED425",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.41 739.89c21.097 0 38.2-11.148 38.2-24.9 0-13.752-17.103-24.9-38.2-24.9s-38.2 11.148-38.2 24.9c0 13.752 17.103 24.9 38.2 24.9z",
    fill: "#FED425",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.61 975.3c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M413.61 939.03c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M413.61 903.75c0 13.75-17.1 24.901-38.2 24.901s-38.2-11.151-38.2-24.901M413.61 868.061c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M413.61 831.37c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M413.61 793.53c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M413.61 755.65c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M413.61 1012.58c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.22 390.92V717c0 13.75 17.1 24.9 38.2 24.9s38.2-11.15 38.2-24.9V392.1l-76.39-1.17-.01-.01z",
    fill: "#FED425",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.41 410.02c21.097 0 38.2-11.148 38.2-24.9 0-13.752-17.103-24.9-38.2-24.9s-38.2 11.148-38.2 24.9c0 13.752 17.103 24.9 38.2 24.9z",
    fill: "#FED425",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.61 645.43c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M413.61 609.16c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M413.61 573.88c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M413.61 538.19c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M413.61 501.5c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M413.61 463.66c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M413.61 425.78c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M413.61 682.71c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.85 720.79v326.08c0 13.75 17.1 24.9 38.2 24.9s38.2-11.15 38.2-24.9v-324.9l-76.39-1.17-.01-.01z",
    fill: "#FED425",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.05 739.89c21.097 0 38.2-11.148 38.2-24.9 0-13.752-17.103-24.9-38.2-24.9s-38.2 11.148-38.2 24.9c0 13.752 17.103 24.9 38.2 24.9z",
    fill: "#FED425",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.25 975.3c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M493.25 939.03c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M493.25 903.75c0 13.75-17.1 24.901-38.2 24.901s-38.2-11.151-38.2-24.901M493.25 868.061c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M493.25 831.37c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M493.25 793.53c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M493.25 755.65c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M493.25 1012.58c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.85 390.92V717c0 13.75 17.1 24.9 38.2 24.9s38.2-11.15 38.2-24.9V392.1l-76.39-1.17-.01-.01z",
    fill: "#FED425",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.05 410.02c21.097 0 38.2-11.148 38.2-24.9 0-13.752-17.103-24.9-38.2-24.9s-38.2 11.148-38.2 24.9c0 13.752 17.103 24.9 38.2 24.9z",
    fill: "#FED425",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.25 645.43c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M493.25 609.16c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M493.25 573.88c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M493.25 538.19c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M493.25 501.5c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M493.25 463.66c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M493.25 425.78c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M493.25 682.71c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.49 720.79v326.08c0 13.75 17.1 24.9 38.2 24.9s38.2-11.15 38.2-24.9v-324.9l-76.39-1.17-.01-.01z",
    fill: "#FED425",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.69 739.89c21.097 0 38.2-11.148 38.2-24.9 0-13.752-17.103-24.9-38.2-24.9s-38.2 11.148-38.2 24.9c0 13.752 17.103 24.9 38.2 24.9z",
    fill: "#FED425",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.88 975.3c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M572.88 939.03c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M572.88 903.75c0 13.75-17.1 24.901-38.2 24.901s-38.2-11.151-38.2-24.901M572.88 868.061c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M572.88 831.37c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M572.88 793.53c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M572.88 755.65c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M572.88 1012.58c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.49 390.92V717c0 13.75 17.1 24.9 38.2 24.9s38.2-11.15 38.2-24.9V392.1l-76.39-1.17-.01-.01z",
    fill: "#FED425",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.69 410.02c21.097 0 38.2-11.148 38.2-24.9 0-13.752-17.103-24.9-38.2-24.9s-38.2 11.148-38.2 24.9c0 13.752 17.103 24.9 38.2 24.9z",
    fill: "#FED425",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.88 645.43c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M572.88 609.16c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M572.88 573.88c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M572.88 538.19c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M572.88 501.5c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M572.88 463.66c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M572.88 425.78c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M572.88 682.71c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.12 720.79v326.08c0 13.75 17.1 24.9 38.2 24.9s38.2-11.15 38.2-24.9v-324.9l-76.39-1.17-.01-.01z",
    fill: "#FED425",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.32 739.89c21.097 0 38.2-11.148 38.2-24.9 0-13.752-17.103-24.9-38.2-24.9s-38.2 11.148-38.2 24.9c0 13.752 17.103 24.9 38.2 24.9z",
    fill: "#FED425",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.52 975.3c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M652.52 939.03c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M652.52 903.75c0 13.75-17.1 24.901-38.2 24.901s-38.2-11.151-38.2-24.901M652.52 868.061c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M652.52 831.37c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M652.52 793.53c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M652.52 755.65c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M652.52 1012.58c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.12 390.92V717c0 13.75 17.1 24.9 38.2 24.9s38.2-11.15 38.2-24.9V392.1l-76.39-1.17-.01-.01z",
    fill: "#FED425",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.32 410.02c21.097 0 38.2-11.148 38.2-24.9 0-13.752-17.103-24.9-38.2-24.9s-38.2 11.148-38.2 24.9c0 13.752 17.103 24.9 38.2 24.9z",
    fill: "#FED425",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.52 645.43c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M652.52 609.16c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M652.52 573.88c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M652.52 538.19c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M652.52 501.5c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M652.52 463.66c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M652.52 425.78c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9M652.52 682.71c0 13.75-17.1 24.9-38.2 24.9s-38.2-11.15-38.2-24.9",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M780.74 346.21c0 56.77-46.02 102.79-102.79 102.79H381.62c-56.77 0-102.79-46.02-102.79-102.79",
    stroke: "#CDE2E4",
    strokeWidth: 32,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.4 211.68H413.39c-73.15 0-132.45 59.3-132.45 132.45v68.02c0 73.15 59.3 132.45 132.45 132.45H650.4c73.15 0 132.45-59.3 132.45-132.45v-68.02c0-73.15-59.3-132.45-132.45-132.45z",
    stroke: "#CDE2E4",
    strokeWidth: 34.16,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.48 259.49c21.097 0 38.2-11.148 38.2-24.9 0-13.752-17.103-24.9-38.2-24.9s-38.2 11.148-38.2 24.9c0 13.752 17.103 24.9 38.2 24.9zM535.69 259.49c21.097 0 38.2-11.148 38.2-24.9 0-13.752-17.103-24.9-38.2-24.9s-38.2 11.148-38.2 24.9c0 13.752 17.103 24.9 38.2 24.9z",
    fill: "#FED425",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.09 259.49c21.097 0 38.2-11.148 38.2-24.9 0-13.752-17.103-24.9-38.2-24.9s-38.2 11.148-38.2 24.9c0 13.752 17.103 24.9 38.2 24.9z",
    fill: "#FED425",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.45 1075.92c16.303 0 29.52-13.22 29.52-29.52 0-16.3-13.217-29.52-29.52-29.52-16.303 0-29.52 13.22-29.52 29.52 0 16.3 13.217 29.52 29.52 29.52z",
    fill: "#F9EDA7",
    stroke: "#AF9E4A",
    strokeWidth: 7.93,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.2 1075.92c16.303 0 29.52-13.22 29.52-29.52 0-16.3-13.217-29.52-29.52-29.52-16.303 0-29.52 13.22-29.52 29.52 0 16.3 13.217 29.52 29.52 29.52zM447.45 1033.28c16.303 0 29.52-13.22 29.52-29.52 0-16.304-13.217-29.52-29.52-29.52-16.303 0-29.52 13.216-29.52 29.52 0 16.3 13.217 29.52 29.52 29.52z",
    fill: "#F9EDA7",
    stroke: "#AF9E4A",
    strokeWidth: 7.93,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.12 992.19c16.303 0 29.52-13.217 29.52-29.52 0-16.304-13.217-29.52-29.52-29.52-16.303 0-29.52 13.216-29.52 29.52 0 16.303 13.217 29.52 29.52 29.52z",
    fill: "#F9EDA7",
    stroke: "#AF9E4A",
    strokeWidth: 7.93,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.78 953.23c16.303 0 29.52-13.217 29.52-29.52 0-16.303-13.217-29.52-29.52-29.52-16.303 0-29.52 13.217-29.52 29.52 0 16.303 13.217 29.52 29.52 29.52z",
    fill: "#F9EDA7",
    stroke: "#AF9E4A",
    strokeWidth: 7.93,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.67 921.38c16.303 0 29.52-13.217 29.52-29.52 0-16.304-13.217-29.52-29.52-29.52-16.303 0-29.52 13.216-29.52 29.52 0 16.303 13.217 29.52 29.52 29.52z",
    fill: "#F9EDA7",
    stroke: "#AF9E4A",
    strokeWidth: 7.93,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.33 882.42c16.303 0 29.52-13.217 29.52-29.52 0-16.304-13.217-29.52-29.52-29.52-16.303 0-29.52 13.216-29.52 29.52 0 16.303 13.217 29.52 29.52 29.52z",
    fill: "#F9EDA7",
    stroke: "#AF9E4A",
    strokeWidth: 7.93,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.17 848.58c16.303 0 29.52-13.216 29.52-29.52 0-16.303-13.217-29.52-29.52-29.52-16.303 0-29.52 13.217-29.52 29.52 0 16.304 13.217 29.52 29.52 29.52z",
    fill: "#F9EDA7",
    stroke: "#AF9E4A",
    strokeWidth: 7.93,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.17 799.85c16.303 0 29.52-13.217 29.52-29.52 0-16.304-13.217-29.52-29.52-29.52-16.303 0-29.52 13.216-29.52 29.52 0 16.303 13.217 29.52 29.52 29.52z",
    fill: "#F9EDA7",
    stroke: "#AF9E4A",
    strokeWidth: 7.93,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.17 752.88c16.303 0 29.52-13.217 29.52-29.52 0-16.304-13.217-29.52-29.52-29.52-16.303 0-29.52 13.216-29.52 29.52 0 16.303 13.217 29.52 29.52 29.52z",
    fill: "#F9EDA7",
    stroke: "#AF9E4A",
    strokeWidth: 7.93,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.774 962.124l-51.541-51.541a7.98 7.98 0 00-11.285 0l-51.541 51.541a7.98 7.98 0 000 11.286l51.541 51.54a7.973 7.973 0 0011.285 0l51.541-51.54a7.98 7.98 0 000-11.286z",
    fill: "#FF1F4F",
    stroke: "#DD0A41",
    strokeWidth: 7.93,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.56 970.25h31.52c1.94 0 3.51-1.57 3.51-3.51V936.1c0-3.1-3.73-4.68-5.96-2.52l-31.52 30.64c-2.26 2.2-.7 6.03 2.45 6.03z",
    fill: "#EFFFD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.721 755.953l-51.541-51.541a7.98 7.98 0 00-11.285 0l-51.541 51.541a7.981 7.981 0 000 11.286l51.541 51.541a7.98 7.98 0 0011.285 0l51.541-51.541a7.98 7.98 0 000-11.286z",
    fill: "#9FFC27",
    stroke: "#7ABA1E",
    strokeWidth: 7.93,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.51 764.08h31.52c1.94 0 3.51-1.57 3.51-3.51v-30.64c0-3.1-3.73-4.68-5.96-2.52l-31.52 30.64c-2.26 2.2-.7 6.03 2.45 6.03z",
    fill: "#EFFFD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M721.202 637.297l-51.541-51.541a7.98 7.98 0 00-11.285 0l-51.541 51.541a7.981 7.981 0 000 11.286l51.541 51.541a7.98 7.98 0 0011.285 0l51.541-51.541a7.98 7.98 0 000-11.286z",
    fill: "#9FFC27",
    stroke: "#7ABA1E",
    strokeWidth: 7.93,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.99 645.43h31.52c1.94 0 3.51-1.57 3.51-3.51v-30.64c0-3.1-3.73-4.68-5.96-2.52l-31.52 30.64c-2.26 2.2-.7 6.03 2.45 6.03z",
    fill: "#EFFFD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.729 303.228l-51.541-51.541a7.98 7.98 0 00-11.286 0l-51.541 51.541a7.98 7.98 0 000 11.285l51.541 51.541a7.981 7.981 0 0011.286 0l51.541-51.541a7.98 7.98 0 000-11.285z",
    fill: "#9FFC27",
    stroke: "#7ABA1E",
    strokeWidth: 7.93,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.52 311.36h31.52c1.94 0 3.51-1.57 3.51-3.51v-30.64c0-3.1-3.73-4.68-5.96-2.52l-31.52 30.64c-2.26 2.2-.7 6.03 2.45 6.03z",
    fill: "#EFFFD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.08 704.66c31.116 0 56.34-25.909 56.34-57.87s-25.224-57.87-56.34-57.87c-31.116 0-56.34 25.909-56.34 57.87s25.224 57.87 56.34 57.87zM577.96 391.64c31.116 0 56.34-25.909 56.34-57.87s-25.224-57.87-56.34-57.87c-31.116 0-56.34 25.909-56.34 57.87s25.224 57.87 56.34 57.87zM697.5 855.2c31.116 0 56.34-25.909 56.34-57.87s-25.224-57.87-56.34-57.87c-31.116 0-56.34 25.909-56.34 57.87s25.224 57.87 56.34 57.87zM491.96 916.94c31.116 0 56.34-25.909 56.34-57.87s-25.224-57.87-56.34-57.87c-31.116 0-56.34 25.909-56.34 57.87s25.224 57.87 56.34 57.87zM195.96 1141.24c31.116 0 56.34-25.91 56.34-57.87 0-31.96-25.224-57.87-56.34-57.87-31.116 0-56.34 25.91-56.34 57.87 0 31.96 25.224 57.87 56.34 57.87z",
    fill: "#FED425",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.3 1141.04c31.116 0 56.34-25.91 56.34-57.87 0-31.96-25.224-57.87-56.34-57.87-31.116 0-56.34 25.91-56.34 57.87 0 31.96 25.224 57.87 56.34 57.87zM839.33 1138.67c31.116 0 56.34-25.91 56.34-57.87 0-31.96-25.224-57.87-56.34-57.87-31.116 0-56.34 25.91-56.34 57.87 0 31.96 25.224 57.87 56.34 57.87zM718.74 145.78l-20.69 40.82c-1.98 3.9-6.74 5.46-10.63 3.48l-49.7-25.19c-3.9-1.98-5.46-6.74-3.48-10.63l47.73-94.16c3.94-7.78.83-17.29-6.95-21.24L645.4 23.85c-7.78-3.94-17.29-.83-21.24 6.95l-47.73 94.16c-1.98 3.9-6.74 5.46-10.63 3.48l-49.7-25.19c-3.9-1.98-5.46-6.74-3.48-10.63l20.69-40.82c3.94-7.78.83-17.29-6.95-21.24l-29.62-15.01c-7.78-3.94-17.29-.83-21.24 6.95l-24.27 47.88-17.98 35.47-34.06 67.19c-3.71 7.32-.78 16.27 6.54 19.99l274.51 139.14c7.32 3.71 16.27.78 19.99-6.54l34.06-67.19 17.98-35.47 24.27-47.88c3.94-7.78.83-17.29-6.95-21.24l-29.62-15.01c-7.78-3.94-17.29-.83-21.24 6.95l.01-.01z",
    fill: "#FED425",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.085 223.194l-18.185-55.57a6.4 6.4 0 00-8.073-4.092l-55.57 18.185a6.398 6.398 0 00-4.092 8.073l18.184 55.57a6.4 6.4 0 008.073 4.092l55.571-18.185a6.4 6.4 0 004.092-8.073z",
    fill: "#FF1F4F",
    stroke: "#DD0A41",
    strokeWidth: 7.93,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.16 195.57L572.71 207c1.39.7 3.08.15 3.78-1.24l11.11-21.93c1.13-2.22-.97-4.7-3.35-3.96l-33.67 10.5c-2.41.75-2.69 4.06-.43 5.2h.01z",
    fill: "#EFFFD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.029 157.829l-10.751-32.855a3.78 3.78 0 00-4.768-2.417l-32.856 10.752a3.78 3.78 0 00-2.417 4.768l10.752 32.855a3.78 3.78 0 004.768 2.417l32.855-10.751a3.78 3.78 0 002.417-4.769z",
    fill: "#FF1F4F",
    stroke: "#DD0A41",
    strokeWidth: 7.93,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.28 141.49l13.33 6.76c.82.42 1.82.09 2.24-.73l6.57-12.96c.67-1.31-.57-2.78-1.98-2.34l-19.9 6.2c-1.43.44-1.59 2.4-.26 3.07z",
    fill: "#EFFFD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M711.28 272.002l-10.751-32.855a3.782 3.782 0 00-4.769-2.417l-32.855 10.751a3.78 3.78 0 00-2.417 4.768l10.751 32.856a3.781 3.781 0 004.769 2.417l32.855-10.752a3.78 3.78 0 002.417-4.768z",
    fill: "#FF1F4F",
    stroke: "#DD0A41",
    strokeWidth: 7.93,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.55 255.67l13.33 6.76c.82.42 1.82.09 2.24-.73l6.57-12.96c.67-1.31-.57-2.78-1.98-2.34l-19.9 6.2c-1.43.44-1.59 2.4-.26 3.07z",
    fill: "#EFFFD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M922.32 1139.43c21.097 0 38.2-13.86 38.2-30.96s-17.103-30.96-38.2-30.96-38.2 13.86-38.2 30.96 17.103 30.96 38.2 30.96z",
    fill: "#FED425",
    stroke: "#FD934F",
    strokeWidth: 14.27,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "jar_7_svg__clip0_1961_6823"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h1288.1v1149.13H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJar7);
export default ForwardRef;